import { useState } from 'react';
import { useIntl } from 'react-intl';

import { isiOSDevice } from 'utils/browser.utils';
import { isProd } from 'utils/env.utils';

import { useFooter } from 'queries/global/useFooter';

const APP_BASE = isProd ? 'nofomo://' : 'partyprep://';

export const useAppRedirect = () => {
  const { storeLinks } = useFooter();
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const fallbackUrl = isiOSDevice()
    ? storeLinks?.appleStoreUrl
    : storeLinks?.googlePlayUrl;

  const onRedirect = (url: string) => {
    setIsLoading(true);
    document.location = new URL(
      `${APP_BASE}${url}${window.location.search}${window.location.hash}`,
    ).href;

    setTimeout(() => {
      if (document?.visibilityState === 'visible') {
        openStore();
      }
      setIsLoading(false);
    }, 1000);
  };

  const openStore = () => {
    if (
      confirm(
        intl.formatMessage({
          id: `general.install_app.${isiOSDevice() ? 'ios' : 'android'}.text`,
        }),
      )
    ) {
      document.location = fallbackUrl ?? '';
    }
  };

  return { onRedirect, openStore, isLoading };
};
